import { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import moment from 'moment';
import getBlogPost from '../../api/getBlogPost';
import Layout from '../../ui/layout';
import Post from '../../ui/blog/post';
import Error from '../../pages/_error';

export default class PostPage extends Component {
  static async getInitialProps({ query }) {
    const { slug } = query;

    try {
      const post = await getBlogPost({
        slug,
      });

      return {
        post,
        hasError: false,
      };
    } catch (e) {
      return {
        hasError: true,
      };
    }
  }

  render() {
    const { post, hasError } = this.props;

    if (hasError) {
      return <Error />;
    }

    if (!post) {
      return <Error statusCode={404} />;
    }

    const { date, title, author, content, image, meta } = post;

    return (
      <Layout>
        <Head>
          <title>{meta.title}</title>
          {meta.description ? (
            <meta name="description" content={meta.description} />
          ) : null}
          <meta property="og:type" content="article" />
          {meta.title ? (
            <meta property="og:title" content={meta.title} />
          ) : null}
          {meta.description ? (
            <meta property="og:description" content={meta.description} />
          ) : null}
          <meta property="og:image" content={image} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@eyefitu" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <Post
          title={title}
          image={image}
          author={`by ${author}`}
          date={moment(date).format('D MMMM YYYY')}
          content={content}
        />
      </Layout>
    );
  }
}

PostPage.propTypes = {
  post: PropTypes.shape({
    date: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    meta: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
  }),
  hasError: PropTypes.bool.isRequired,
};

PostPage.defaultProps = {
  post: null,
};
